import * as React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "features/auth";
import { getCookie } from "utils/storage";

const cookieKey = "HUG_ignore-profile-complete";

const setCookie = () => {
  // Ignore cookie will expire in 24 hours
  document.cookie = `${cookieKey}=true;max-age=${60 * 60 * 24}`;
};

/**
 * Check if logged in user needs to be prompted to complete their profile
 */
const useProfileCompleteCheck = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Initial popup state is based on whether the user shows completion OR the ignore cookie exists
  const [showProfileCompletePopup, setShowProfileCompletePopup] =
    React.useState(
      !!user?.profileCompletedAt || getCookie(cookieKey) !== "true"
    );

  // If the user navigates to the Profile Edit page, turn off the popup
  React.useEffect(() => {
    if (location.pathname === "/profile/edit") {
      setShowProfileCompletePopup(false);
    }
  }, [location.pathname, setShowProfileCompletePopup]);

  // If the user object gets updated (because they edited their profile), turn off the popup
  React.useEffect(() => {
    if (user?.profileCompletedAt) {
      setShowProfileCompletePopup(false);
    }
  }, [user?.profileCompletedAt, setShowProfileCompletePopup]);

  /**
   * Hide profile completion popup and set ignore cookie
   */
  const ignoreProfileCompletePopup = () => {
    setShowProfileCompletePopup(false);
    setCookie();
  };

  return { showProfileCompletePopup, ignoreProfileCompletePopup };
};

export { useProfileCompleteCheck };
